<app-staff [enableSalaryRaise]="true"></app-staff>


